import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cf76256"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "active"]




export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
    modelValue: { type: Boolean },
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "toggle-button",
    type: "button",
    disabled: _ctx.disabled,
    active: _ctx.modelValue || null,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', !_ctx.modelValue)))
  }, null, 8, _hoisted_1))
}
}

})